import { useMutation } from "@tanstack/react-query";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../constants/firebaseModular";
import { UpdateFileRefPayload, Chart } from "@usacsmideo/types";
import * as Sentry from "@sentry/browser";
import { APPLICATION_STATUS, createLastUpdated, UPDATE_SOURCE } from "../utilities/updateHelpers";

const updateFileReference = async (payload: UpdateFileRefPayload) => {
  const docTitle = Object.keys(payload)[0] as keyof Chart;
  const patientId = payload[docTitle].patientId;

  // UPDATE THE CHART SUBCOLLECTION DOCUMENT
  const chartDocRef = doc(db, "users", patientId, "Chart", docTitle);
  const data = payload[docTitle];

  try {
    await setDoc(chartDocRef, data.docData, { merge: true });
  } catch (error) {
    // REPORT HERE, THEN RETHROW THE SAME INSTANCE — AS useUpdateChartSection DOES. UNTIL CU-17tm466jq2e
    // A REJECTED FILE-REFERENCE WRITE REACHED NEITHER SENTRY NOR THE PATIENT (MEASURED ON STAGING).
    Sentry.captureException(error, { tags: { chartDoc: docTitle, chartWrite: "chart" } });
    throw error;
  }

  // UPDATE lastUpdated ON THE PARENT USER DOCUMENT
  const userDocRef = doc(db, "users", patientId);
  const lastUpdated = createLastUpdated(UPDATE_SOURCE.PORTAL, patientId);

  await setDoc(userDocRef, { lastUpdated, applicationStatus: APPLICATION_STATUS.OPEN }, { merge: true }).catch((error) => {
    console.error("[updateFileReference] Failed to update lastUpdated:", error);
    Sentry.captureException(error);
    // DON'T THROW HERE - FILE UPLOAD SUCCEEDED, lastUpdated IS SECONDARY
  });
};

export const useUpdateFileReference = () => {
  return useMutation({
    mutationFn: (payload: UpdateFileRefPayload) => updateFileReference(payload),
  });
};
